var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelYoutubeSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 10,
  viewBox: "0 0 14 10",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7.115 0c.815.006 5.591.069 6.204.71.674.702.681 4.167.681 4.187v.105c-.008.586-.075 3.451-.68 4.082-.614.64-5.39.708-6.205.715H6.88c-.814-.007-5.59-.074-6.205-.715-.6-.626-.666-3.451-.673-4.068v-.237C.008 4.166.074 1.336.674.71 1.29.07 6.065.007 6.88.002ZM4.9 2.1v5.6l5.6-2.8z"
})));
export default SvgChannelYoutubeSm;